<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible="visible"
      direction="rtl"
      :size="1200"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div style="padding: 20px;">
        <FabricInfo
          :fabricDisabled="fabricDisabled"
          :isFabricCopy="isCopy"
          :fabricInfoCode="fabricCode"
          :fabricSeriesCode="fabricSeriesCode"
          :form="form"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import FabricInfo from '@/views/ecom/awsSample/fabric/detail/index.vue'
export default {
  components: { FabricInfo },
  props: {
    title: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    fabricDisabled: { type: Boolean, default: false },
    isCopy: { type: Boolean, default: false },
    fabricCode: { type: String, default: '' },
    fabricSeriesCode: { type: String, default: '' },
    form: { type: Object, default: () => {} },
  },
  methods: {
    close() {
      if (!this.fabricDisabled) this.$emit('close')
      this.$emit('update:visible', false)
    },

    handleClose(done) {
      if (this.fabricDisabled) {
        done()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 10px 12px;
}

::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
</style>
